export const i18n = {
  defaultLocale: 'en',
  locales: ['en', 'nl', 'de', 'it', 'fr'] as const,
  trailingSlash: false // Make sure this is false
} as const;

export type Locale = (typeof i18n)['locales'][number];
